import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 10,
		fill: "#0050a0",
		r: 10
	}), /* @__PURE__ */ _jsxs("g", {
		stroke: "#8cd7fa",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", { d: "m9.99974 13.6365v-7.27296" }), /* @__PURE__ */ _jsx("path", { d: "m13.6362 10h-7.27292" })]
	})]
});
export default SvgAddActive;
